document.addEventListener('DOMContentLoaded',()=>{
  const hideNativeThemeChrome=()=>{
    if(!document.querySelector('.tl-header,.tl-page,.tl-pdp,.tl-about-v2'))return;
    [
      '#header-group',
      '.shopify-section-group-header-group',
      '.section-header',
      '[id*="__announcement-bar"]',
      '[id*="__header"]'
    ].forEach(selector=>{
      document.querySelectorAll(selector).forEach(node=>{
        if(!node.querySelector('.tl-header,.tl-announcement')){
          node.style.setProperty('display','none','important');
          node.setAttribute('aria-hidden','true');
        }
      });
    });
  };
  hideNativeThemeChrome();
  document.querySelectorAll('[data-tl-hero-video]').forEach(video=>{
    video.muted=true;
    const play=()=>video.play().catch(()=>{});
    if(document.visibilityState==='visible') play();
    document.addEventListener('visibilitychange',()=>{
      if(document.visibilityState==='visible') play(); else video.pause();
    });
  });
  document.querySelectorAll('[data-tl-clinical]').forEach(root=>{
    root.querySelectorAll('[data-clinical-tab]').forEach(tab=>tab.addEventListener('click',()=>{
      const key=tab.dataset.clinicalTab;
      root.querySelectorAll('[data-clinical-tab]').forEach(item=>{
        item.classList.remove('is-active');
        item.setAttribute('aria-selected','false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected','true');
      root.querySelectorAll('[data-clinical-detail]').forEach(panel=>{
        panel.hidden=panel.dataset.clinicalDetail!==key;
        panel.querySelectorAll('video').forEach(video=>panel.hidden?video.pause():video.play().catch(()=>{}));
      });
      root.querySelectorAll('[data-clinical-chart]').forEach(chart=>chart.hidden=chart.dataset.clinicalChart!==key);
    }));

    const modal=root.querySelector('[data-clinical-video-modal]');
    const player=root.querySelector('[data-clinical-video-player]');
    const closeVideo=()=>{
      if(!modal||!player)return;
      player.pause();
      player.removeAttribute('src');
      player.load();
      modal.hidden=true;
      document.body.classList.remove('tl-modal-open');
    };
    root.querySelectorAll('[data-clinical-video-open]').forEach(button=>button.addEventListener('click',()=>{
      if(!modal||!player||!button.dataset.videoSrc)return;
      player.src=button.dataset.videoSrc;
      modal.hidden=false;
      document.body.classList.add('tl-modal-open');
      player.play().catch(()=>{});
    }));
    root.querySelectorAll('[data-clinical-video-close]').forEach(button=>button.addEventListener('click',closeVideo));
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&modal&&!modal.hidden)closeVideo();});
  });
  document.querySelectorAll('[data-tl-comparison]').forEach(root=>{
    const title=root.querySelector('[data-comparison-title]');
    root.querySelectorAll('[data-comparison-tab]').forEach(tab=>tab.addEventListener('click',()=>{
      const key=tab.dataset.comparisonTab;
      root.querySelectorAll('[data-comparison-tab]').forEach(item=>{
        const active=item===tab;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-selected',active?'true':'false');
      });
      root.querySelectorAll('[data-comparison-panel]').forEach(panel=>{
        panel.hidden=panel.dataset.comparisonPanel!==key;
      });
      if(title&&tab.dataset.title) title.textContent=tab.dataset.title;
    }));
  });
  document.querySelectorAll('[data-tl-community]').forEach(root=>{
    root.querySelectorAll('.tl-community-video').forEach(card=>{
      const video=card.querySelector('video');
      const button=card.querySelector('[data-community-play]');
      const media=card.querySelector('.tl-community-video__media');
      if(!video||!button||!media)return;
      const setState=playing=>{
        media.classList.toggle('is-playing',playing);
        button.setAttribute('aria-pressed',playing?'true':'false');
        button.setAttribute('aria-label',(playing?'Pause ':'Play ')+(card.querySelector('.tl-community-video__handle')?.textContent||'community')+' video');
      };
      const toggle=()=>{
        if(video.paused){
          root.querySelectorAll('video').forEach(other=>{if(other!==video){other.pause();other.closest('.tl-community-video__media')?.classList.remove('is-playing');}});
          video.muted=false;
          video.play().then(()=>setState(true)).catch(()=>{});
        }else{
          video.pause();
          setState(false);
        }
      };
      button.addEventListener('click',toggle);
      video.addEventListener('click',toggle);
      video.addEventListener('pause',()=>setState(false));
    });
  });
  document.querySelectorAll('[data-tl-experts]').forEach(root=>{
    const tabs=[...root.querySelectorAll('[data-expert-tab]')];
    const panels=[...root.querySelectorAll('[data-expert-panel]')];
    const visuals=[...root.querySelectorAll('[data-expert-visual]')];
    if(!tabs.length)return;
    let current=Math.max(0,tabs.findIndex(tab=>tab.classList.contains('is-active')));
    let timer;
    const activate=index=>{
      current=(index+tabs.length)%tabs.length;
      tabs.forEach((tab,i)=>{
        const active=i===current;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active?'true':'false');
      });
      panels.forEach((panel,i)=>{
        const active=i===current;
        panel.hidden=!active;
        panel.classList.toggle('is-active',active);
      });
      visuals.forEach((visual,i)=>{
        const active=i===current;
        visual.hidden=!active;
        visual.classList.toggle('is-active',active);
      });
    };
    const stop=()=>{if(timer)window.clearInterval(timer);timer=undefined;};
    const start=()=>{
      stop();
      if(root.dataset.autoplay!=='true')return;
      const interval=Math.max(4000,Number(root.dataset.interval)||7000);
      timer=window.setInterval(()=>activate(current+1),interval);
    };
    tabs.forEach((tab,index)=>tab.addEventListener('click',()=>{activate(index);start();}));
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget))start();});
    start();
  });
  if(document.querySelector('.tl-page,.tl-product-page')){
    const header=document.getElementById('header-group');
    const footer=document.getElementById('footer-group');
    if(header) header.style.setProperty('display','none','important');
    if(footer) footer.style.setProperty('display','none','important');
    document.body.style.setProperty('margin','0','important');
    document.body.style.setProperty('padding','0','important');
    const main=document.getElementById('MainContent');
    if(main){main.style.setProperty('width','100%','important');main.style.setProperty('max-width','none','important');main.style.setProperty('padding','0','important');}
  }
  document.querySelectorAll('[data-tl-product-root]').forEach(root=>{
    root.querySelectorAll('[data-tl-gallery-video]').forEach(video=>{
      video.muted=true;
      video.play().catch(()=>{});
    });
  });
  document.querySelectorAll('[data-tl-timeline]').forEach(root=>{
    const setActive=(item)=>{
      if(!item)return;
      root.querySelectorAll('.tl-time').forEach(node=>node.classList.toggle('is-active',node===item));
      root.querySelectorAll('[data-tl-time]').forEach(node=>node.setAttribute('aria-expanded',node.closest('.tl-time')===item?'true':'false'));
      item.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    };
    root.querySelectorAll('[data-tl-time]').forEach(button=>button.addEventListener('click',()=>{
      setActive(button.closest('.tl-time'));
    }));
    const section=root.closest('.tl-timeband');
    section?.querySelector('[data-tl-timeline-prev]')?.addEventListener('click',()=>{
      const items=[...root.querySelectorAll('.tl-time')];
      const index=Math.max(0,items.findIndex(item=>item.classList.contains('is-active'))-1);
      setActive(items[index]);
    });
    section?.querySelector('[data-tl-timeline-next]')?.addEventListener('click',()=>{
      const items=[...root.querySelectorAll('.tl-time')];
      const current=items.findIndex(item=>item.classList.contains('is-active'));
      const index=Math.min(items.length-1,(current<0?0:current+1));
      setActive(items[index]);
    });
  });
  document.querySelectorAll('[data-tl-clinician-toggle]').forEach(button=>{
    button.addEventListener('click',()=>{
      const card=button.closest('.tl-clinician');
      if(!card)return;
      const expanded=!card.classList.contains('is-expanded');
      card.classList.toggle('is-expanded',expanded);
      button.textContent=expanded ? (button.dataset.less || 'Show less') : (button.dataset.more || 'Show more');
    });
  });
  document.querySelectorAll('[data-tl-thumb]').forEach(btn=>btn.addEventListener('click',()=>{
    const target=document.querySelector(btn.dataset.tlThumb);
    if(target) target.scrollIntoView({behavior:'smooth',block:'center'});
  }));
  document.querySelectorAll('[data-tl-menu]').forEach(btn=>btn.addEventListener('click',()=>{
    const nav=btn.closest('.tl-nav').querySelector('.tl-nav__links');
    nav.style.display=nav.style.display==='flex'?'none':'flex';
  }));
});

(()=>{
  const toCents=value=>{
    if(value===null||value===undefined||value==='')return 0;
    if(typeof value==='string'&&value.includes('.'))return Math.round(Number(value)*100)||0;
    return Math.round(Number(value))||0;
  };
  const moneyFormat=cents=>{
    const value=toCents(cents)/100;
    return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:value%1?2:0}).format(value);
  };
  const bindPurchaseBox=root=>{
    if(!root||root.dataset.tlPriceBound==='true')return;
    const buy=root.querySelector('[data-tl-buy]');
    const variantsNode=buy?.querySelector('[data-tl-variants-json]');
    if(!buy||!variantsNode)return;
    root.dataset.tlPriceBound='true';
    let variants=[];
    try{variants=JSON.parse(variantsNode.textContent||'[]');}catch(error){variants=[];}
    if(!variants.length)return;

    const variantInput=buy.querySelector('[data-tl-variant-id]');
    const variantSelect=buy.querySelector('[data-tl-variant-select]');
    const qtyInput=buy.querySelector('[data-tl-quantity]');
    const currentNode=buy.querySelector('[data-tl-current]');
    const compareNode=buy.querySelector('[data-tl-compare]');
    const discountNode=buy.querySelector('[data-tl-discount]');
    const addPrice=buy.querySelector('[data-tl-add-price]');
    const checkoutPrice=buy.querySelector('[data-tl-checkout-price]');
    const checkoutButton=buy.querySelector('[data-tl-direct-checkout]');
    const priceStack=buy.querySelector('[data-tl-price]');

    const getQty=()=>Math.max(1,Math.min(99,parseInt(qtyInput?.value||'1',10)||1));
    const getQuantityDiscountPercent=qty=>{
      const tiers=[
        {qty:Number(buy.dataset.tierOneQty)||0,percent:Number(buy.dataset.tierOnePercent)||0},
        {qty:Number(buy.dataset.tierTwoQty)||0,percent:Number(buy.dataset.tierTwoPercent)||0}
      ].filter(tier=>tier.qty>0&&tier.percent>0&&qty>=tier.qty).sort((a,b)=>b.qty-a.qty||b.percent-a.percent);
      return Math.max(0,Math.min(100,tiers[0]?.percent||0));
    };
    const getVariant=()=>{
      const selectedOption=variantSelect?.selectedOptions?.[0];
      const id=Number(variantSelect?.value||variantInput?.value||variants[0].id);
      const variant=variants.find(item=>Number(item.id)===id)||variants[0];
      return {
        ...variant,
        price: toCents(variant?.price||selectedOption?.dataset.unitPrice||priceStack?.dataset.unitPrice),
        compare_at_price: toCents(variant?.compare_at_price||selectedOption?.dataset.unitCompare||priceStack?.dataset.unitCompare),
        available: variant?.available!==false
      };
    };
    const refresh=()=>{
      const variant=getVariant();
      const qty=getQty();
      if(qtyInput)qtyInput.value=qty;
      if(variantInput)variantInput.value=variant.id;
      const unitPrice=toCents(variant.price);
      const unitCompare=toCents(variant.compare_at_price);
      const quantityDiscountPercent=getQuantityDiscountPercent(qty);
      const lineBeforeQuantityDiscount=unitPrice*qty;
      const linePrice=Math.round(lineBeforeQuantityDiscount*(100-quantityDiscountPercent)/100);
      const lineCompare=(unitCompare>unitPrice?unitCompare:unitPrice)*qty;
      const lineSavings=Math.max(0,lineCompare-linePrice);
      const lineDiscountPercent=lineCompare>0?Math.round(lineSavings*100/lineCompare):0;

      if(currentNode)currentNode.textContent=moneyFormat(linePrice);
      if(addPrice)addPrice.textContent=moneyFormat(linePrice);
      if(checkoutPrice)checkoutPrice.textContent=moneyFormat(linePrice);
      if(compareNode){
        compareNode.hidden=!(lineCompare>linePrice);
        compareNode.textContent=lineCompare>linePrice?moneyFormat(lineCompare):'';
      }
      if(discountNode){
        discountNode.hidden=!(lineSavings>0);
        discountNode.textContent=lineSavings>0?`Save ${moneyFormat(lineSavings)} (${lineDiscountPercent}%)`:'';
      }
      buy.dataset.tlQuantity=String(qty);
      buy.dataset.tlUnitPrice=String(unitPrice);
      buy.dataset.tlUnitCompare=String(unitCompare);
      buy.dataset.tlLinePrice=String(linePrice);
      buy.dataset.tlLineCompare=String(lineCompare);
      buy.dataset.tlLineSavings=String(lineSavings);
      buy.dataset.tlQuantityDiscountPercent=String(quantityDiscountPercent);
      buy.querySelectorAll('.tl-add,.tl-checkout').forEach(button=>{button.disabled=variant.available===false;});
    };

    buy.addEventListener('click',event=>{
      const minus=event.target.closest('[data-tl-qty-minus]');
      const plus=event.target.closest('[data-tl-qty-plus]');
      if(minus||plus){
        event.preventDefault();
        if(qtyInput)qtyInput.value=getQty()+(plus?1:-1);
        refresh();
      }
    });
    qtyInput?.addEventListener('input',refresh);
    qtyInput?.addEventListener('change',refresh);
    qtyInput?.addEventListener('keyup',refresh);
    variantSelect?.addEventListener('change',refresh);
    checkoutButton?.addEventListener('click',()=>{
      const variant=getVariant();
      const qty=getQty();
      if(!variant||variant.available===false)return;
      window.location.href=`/cart/${variant.id}:${qty}?checkout`;
    });
    refresh();
  };
  const init=scope=>{
    (scope||document).querySelectorAll('[data-tl-product-root]').forEach(bindPurchaseBox);
  };
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>init(document));
  }else{
    init(document);
  }
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
